export const otp = {
    title:"セキュリティ認証",
    label:"メール認証コード",
    content:"送信された 6 桁のコードを入力してください",
    button:"確認",
    backToLogin: "ログインに戻る",
    receivedCode: "コードをまだ受け取っていませんか？ 後で新しいコードをリクエストしてください",
    seconds: "{seconds} 秒",
    receivedCodeYet:"コードをまだ受け取っていませんか？",
    resendCode: "コードを再送信"
};
